const binding = { modules: {}, dataActions: {} };

    (binding.modules['dyn-tile-list'] = {
        c: () => require('partner/modules/dyn-tile-list/dyn-tile-list.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dyn-tile-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dyn-tile-list'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dyn-tile-list|dyn-tile-list'] = {
                c: () => require('partner/modules/dyn-tile-list/dyn-tile-list.view.tsx'),
                cn: '__local__-__local__-dyn-tile-list'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };